import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";

import Layout from "~/components/UI/Layout/Layout";
import List from "./List";
import { loadDividas } from "./actions";
import usePersistedFilters from '~/_shared/hooks/usePersistedFilters';
import {
    DIVIDAS_FILTERS_KEY,
    getDefaultDividasFilters,
    normalizeDividasFilters,
    getDividasRequest,
} from './helpers';

export var ScreensDividasTributarias = function() {
    var dispatch = useDispatch();

    var [isLoading, setIsLoading] = useState(true);

    // Filters kept across refreshes for a few minutes (per tenant/user/page).
    var persisted = usePersistedFilters(DIVIDAS_FILTERS_KEY, getDefaultDividasFilters);
    var applied = normalizeDividasFilters(persisted.filters);
    var showArchived = applied.showArchived;

    // Keeps the loader on until the latest request answers.
    var requestId = useRef(0);

    // Loads the restored (or default) view on mount and whenever it changes.
    useEffect(function() {
        loadData(showArchived);
    }, [showArchived]);

    function loadData(archived) {
        var id = ++requestId.current;
        setIsLoading(true);
        dispatch(loadDividas(getDividasRequest({ showArchived: archived }))).then(function() {
            if (id === requestId.current) setIsLoading(false);
        }).catch(function(error) {
            console.log(error);
            if (id === requestId.current) setIsLoading(false);
        });
    }

    function handleToggleArchived() {
        persisted.setFilters({ showArchived: !showArchived });
    }

    return (
        <Layout>
            <List
                isLoading={isLoading}
                onRefresh={function() { loadData(showArchived); }}
                showArchived={showArchived}
                onToggleArchived={handleToggleArchived}
                persisted={persisted}
                applied={applied}
            />
        </Layout>
    );
};
